/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/external_bank_account';
import '../../models/plaid_link';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "LinkExternalBankAccountWithPlaidRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "plaidPublicToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "plaidAccountId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "plaidVerificationStatus": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "gringottsSessionToken": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "LinkExternalBankAccountWithPlaidResponse": {
                    "fields": {
                      "externalBankAccount": {
                        "type": ".squareup.sfs.external.models.ExternalBankAccount",
                        "id": 1,
                        "rule": "optional"
                      },
                      "verifyingPlaidLink": {
                        "type": ".squareup.sfs.external.models.PlaidLink",
                        "id": 2,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.LinkExternalBankAccountWithPlaidRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.LinkExternalBankAccountWithPlaidResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LinkExternalBankAccountWithPlaidRequest @ squareup/sfs/external/services/external_bank_account/link_external_bank_account_with_plaid.proto at 10:1
 */
export const LinkExternalBankAccountWithPlaidRequest = $root.lookupType('squareup.sfs.external.service.LinkExternalBankAccountWithPlaidRequest');
fixType(LinkExternalBankAccountWithPlaidRequest, {
  idempotencyKey: {
    notEmpty: true
  },
  customerId: {
    required: true
  },
  plaidPublicToken: {
    required: true
  },
  plaidAccountId: {
    required: true
  },
  plaidVerificationStatus: {
    required: true
  }
});
Builder.createAndAttachToType(LinkExternalBankAccountWithPlaidRequest);
/**
 * SOURCE LinkExternalBankAccountWithPlaidResponse @ squareup/sfs/external/services/external_bank_account/link_external_bank_account_with_plaid.proto at 42:1
 */
export const LinkExternalBankAccountWithPlaidResponse = $root.lookupType('squareup.sfs.external.service.LinkExternalBankAccountWithPlaidResponse');
fixType(LinkExternalBankAccountWithPlaidResponse);
Builder.createAndAttachToType(LinkExternalBankAccountWithPlaidResponse);